var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0013 3.33329C13.6771 3.33329 16.668 6.32413 16.668 9.99996C16.668 13.6758 13.6771 16.6666 10.0013 16.6666C6.32547 16.6666 3.33464 13.6758 3.33464 9.99996C3.33464 6.32413 6.32547 3.33329 10.0013 3.33329ZM10.0013 1.66663C5.3988 1.66663 1.66797 5.39746 1.66797 9.99996C1.66797 14.6025 5.3988 18.3333 10.0013 18.3333C14.6038 18.3333 18.3346 14.6025 18.3346 9.99996C18.3346 5.39746 14.6038 1.66663 10.0013 1.66663ZM13.3346 8.33329C13.3346 7.44924 12.9834 6.60139 12.3583 5.97627C11.7332 5.35115 10.8854 4.99996 10.0013 4.99996C9.11725 4.99996 8.2694 5.35115 7.64428 5.97627C7.01916 6.60139 6.66797 7.44924 6.66797 8.33329H8.33464C8.33464 7.41413 9.08214 6.66663 10.0013 6.66663C10.9205 6.66663 11.668 7.41413 11.668 8.33329C11.668 9.25246 10.9205 9.99996 10.0013 9.99996C9.78029 9.99996 9.56833 10.0878 9.41205 10.244C9.25577 10.4003 9.16797 10.6123 9.16797 10.8333V12.5H10.8346V11.5491C11.5489 11.366 12.182 10.9508 12.6345 10.3687C13.0871 9.78659 13.3333 9.07061 13.3346 8.33329ZM10.8346 13.3333H9.16797V15H10.8346V13.3333Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.eb1045ef9c34d0d3ab155ea12cead272.svg";
export { ForwardRef as ReactComponent };